import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CategoriesOfProductPage = () => {
  const [categories, setCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const getData = (count = 5, offset = 0) => {
    apiRequests.products.getCategories(count, offset).then((res) => setCategories(res));
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.products.getCategoriesFiltered(searchValue).then((res) => setCategories(res));
    }
  };

  const handleDelete = (id) => {
    apiRequests.products.deleteCategory(id).then(() =>
      setCategories((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {categories.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          categories.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`${location.pathname}/${item.id}`}
              localizationLink={`${location.pathname}/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={categories.totalCount}
        itemsPerPage={5}
        onChange={(page) => getData(5, 5 * page)}
      />
    </>
  );
};

export default CategoriesOfProductPage;
